var _defs, _polyline, _g, _g2, _circle, _circle2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path, _path2, _g10, _path3, _path4, _path5, _path6, _circle3, _line, _polyline2, _polyline3, _polyline4, _polyline5, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 264",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-dasharray:0 0 0 4;}.cls-1,.cls-2,.cls-3{stroke:#020210;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-1,.cls-3{fill:none;}.cls-4,.cls-2{fill:#fff;}.cls-5{fill:#f1961d;}.cls-6{fill:#b5b5b5;}.cls-7{fill:#419977;}.cls-8{fill:#6d6d6d;}.cls-9{fill:#50ba94;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "389 263 389 199 417 199 417 263"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "229 91 215 59 201 91"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 193,
    y: 139,
    width: 44,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 197,
    y: 99,
    width: 36,
    height: 112
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 201,
    y: 191,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209,
    y: 191,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217,
    y: 191,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225,
    y: 191,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 201,
    y: 179,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209,
    y: 179,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217,
    y: 179,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225,
    y: 179,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 201,
    y: 155,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209,
    y: 155,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217,
    y: 155,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225,
    y: 155,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 201,
    y: 167,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 209,
    y: 167,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217,
    y: 167,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 225,
    y: 167,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 197,
    y1: 143,
    x2: 197,
    y2: 211
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233,
    y1: 143,
    x2: 233,
    y2: 211
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 197,
    y1: 99,
    x2: 197,
    y2: 139
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233,
    y1: 99,
    x2: 233,
    y2: 139
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "229 91 215 59 201 91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 215,
    cy: 119,
    r: 12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219,
    y1: 112.07,
    x2: 219,
    y2: 112.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211,
    y1: 125.93,
    x2: 211,
    y2: 125.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.93,
    y1: 115,
    x2: 221.93,
    y2: 115
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.07,
    y1: 123,
    x2: 208.07,
    y2: 123
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223,
    y1: 119,
    x2: 223,
    y2: 119
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 207,
    y1: 119,
    x2: 207,
    y2: 119
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.93,
    y1: 123,
    x2: 221.93,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.07,
    y1: 115,
    x2: 208.07,
    y2: 115
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219,
    y1: 125.93,
    x2: 219,
    y2: 125.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211,
    y1: 112.07,
    x2: 211,
    y2: 112.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215,
    y1: 127,
    x2: 215,
    y2: 127
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215,
    y1: 111,
    x2: 215,
    y2: 111
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211,
    y1: 125.93,
    x2: 211,
    y2: 125.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219,
    y1: 112.07,
    x2: 219,
    y2: 112.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.07,
    y1: 123,
    x2: 208.07,
    y2: 123
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.93,
    y1: 115,
    x2: 221.93,
    y2: 115
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 207,
    y1: 119,
    x2: 207,
    y2: 119
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 223,
    y1: 119,
    x2: 223,
    y2: 119
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 208.07,
    y1: 115,
    x2: 208.07,
    y2: 115
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 221.93,
    y1: 123,
    x2: 221.93,
    y2: 123
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 211,
    y1: 112.07,
    x2: 211,
    y2: 112.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 219,
    y1: 125.93,
    x2: 219,
    y2: 125.93
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215,
    y1: 111,
    x2: 215,
    y2: 111
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 215,
    y1: 127,
    x2: 215,
    y2: 127
  })))), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 215,
    y1: 59,
    x2: 215,
    y2: 47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 215,
    cy: 45,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 193,
    y: 139,
    width: 44,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "233 87 233 91 229 91 229 87 225 87 225 91 221 91 221 87 217 87 217 91 213 91 213 87 209 87 209 91 205 91 205 87 201 87 201 91 197 91 197 87 193 87 193 91 193 99 197 99 201 99 205 99 209 99 213 99 217 99 221 99 225 99 229 99 233 99 237 99 237 91 237 87 233 87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233 87 233 91 229 91 229 87 225 87 225 91 221 91 221 87 217 87 217 91 213 91 213 87 209 87 209 91 205 91 205 87 201 87 201 91 197 91 197 87 193 87 193 91 193 99 197 99 201 99 205 99 209 99 213 99 217 99 221 99 225 99 229 99 233 99 237 99 237 91 237 87 233 87"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 215,
    y1: 119,
    x2: 215,
    y2: 115
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 215,
    y1: 119,
    x2: 219,
    y2: 119
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195,
    y1: 103,
    x2: 235,
    y2: 103
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195,
    y1: 147,
    x2: 235,
    y2: 147
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195,
    y1: 135,
    x2: 235,
    y2: 135
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 195,
    y1: 207,
    x2: 235,
    y2: 207
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 305,
    y: 195,
    width: 28,
    height: 68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 305,
    y: 191,
    width: 30,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 305,
    y: 183,
    width: 24,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 305,
    y: 179,
    width: 26,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M325,179c0-13.27-10.73-24-24-24v24h24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M325,179c0-13.27-10.73-24-24-24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 329,
    y1: 183,
    x2: 329,
    y2: 191
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 333,
    y1: 195,
    x2: 333,
    y2: 263
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311,203c-1.1,0-2,.9-2,2v6h4v-6c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319,203c-1.1,0-2,.9-2,2v6h4v-6c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327,203c-1.1,0-2,.9-2,2v6h4v-6c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327,215c-1.1,0-2,.9-2,2v6h4v-6c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319,215c-1.1,0-2,.9-2,2v6h4v-6c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311,215c-1.1,0-2,.9-2,2v6h4v-6c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 325,
    y1: 187,
    x2: 325,
    y2: 187
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 321,
    y1: 187,
    x2: 307,
    y2: 187
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 305,
    y1: 187,
    x2: 305,
    y2: 187
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "305 195 335 195 335 191 305 191"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "305 183 331 183 331 179 305 179"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 333,
    cy: 260,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 259,
    cy: 23,
    r: 22
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 91.17,
    y: 191,
    width: 75.67,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.17,
    y1: 131,
    x2: 129.17,
    y2: 111
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 129.17,
    cy: 110,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M129.17,131c-1.1,0-2,.9-2,2v10h4v-10c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 129.17,
    cy: 125,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 125.17,
    y: 143,
    width: 8,
    height: 14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 93.17,
    y: 195,
    width: 72,
    height: 68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 99.17,
    y: 211,
    width: 60,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.17,191c0-18.78-15.22-34-34-34s-34,15.22-34,34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 91.17,
    y1: 247,
    x2: 166.83,
    y2: 247
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 165.17,
    y1: 195,
    x2: 165.17,
    y2: 263
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 155.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 155.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 131.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 123.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 115.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 107.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.17,
    y: 239,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 99.17,
    y: 239,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.17,
    y: 239,
    width: 4,
    height: 4
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M163.17,191c0-18.78-15.22-34-34-34s-34,15.22-34,34"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 163.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 155.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.17,
    y: 191,
    width: 4,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 91.17,
    y: 191,
    width: 4,
    height: 4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 159.17,
    y1: 195,
    x2: 163.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 159.17,
    y1: 191,
    x2: 163.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.17,
    y1: 195,
    x2: 155.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.17,
    y1: 191,
    x2: 155.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.17,
    y1: 195,
    x2: 147.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 143.17,
    y1: 191,
    x2: 147.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.17,
    y1: 195,
    x2: 139.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 135.17,
    y1: 191,
    x2: 139.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 127.17,
    y1: 195,
    x2: 131.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 127.17,
    y1: 191,
    x2: 131.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.17,
    y1: 195,
    x2: 123.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.17,
    y1: 191,
    x2: 123.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 111.17,
    y1: 195,
    x2: 115.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 111.17,
    y1: 191,
    x2: 115.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.17,
    y1: 195,
    x2: 107.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 103.17,
    y1: 191,
    x2: 107.17,
    y2: 191
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 95.17,
    y1: 195,
    x2: 99.17,
    y2: 195
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 95.17,
    y1: 191,
    x2: 99.17,
    y2: 191
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 155.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 155.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 147.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 147.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 139.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 139.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 131.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 131.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 123.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 123.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 115.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 107.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 107.17,
    y: 199,
    width: 4,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 99.17,
    y: 199,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 99.17,
    y: 199,
    width: 4,
    height: 8
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "159.17 231 99.17 231 99.17 211 159.17 211 159.17 231"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 119.17,
    y1: 211,
    x2: 119.17,
    y2: 231
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 139.17,
    y1: 211,
    x2: 139.17,
    y2: 231
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "125.17 157 125.17 143 133.17 143 133.17 157"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 123.17,
    y1: 143,
    x2: 125.17,
    y2: 143
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 133.17,
    y1: 143,
    x2: 135.17,
    y2: 143
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.17,131c-1.1,0-2,.9-2,2v10h4v-10c0-1.1-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 129.17,
    cy: 125,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.17,191c0-18.79,11.63-34,26-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.17,191c0-18.79-11.63-34-26-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.17,191c0-18.79-8.05-34-18-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M111.17,191c0-18.79,8.05-34,18-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.17,191c0-18.79,4.47-34,10-34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.17,191c0-18.79-4.47-34-10-34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 129.17,
    y1: 157,
    x2: 129.17,
    y2: 191
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 93.17,
    y1: 195,
    x2: 93.17,
    y2: 263
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 99.17,
    y: 251,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.17,
    y: 251,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.17,
    y: 251,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 139.17,
    y: 251,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 147.17,
    y: 251,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 154.83,
    y: 251,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "123.17 263 123.17 251 135.17 251 135.17 263"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 341,
    y: 219,
    width: 52,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339,
    y: 243,
    width: 56,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339,
    y: 215,
    width: 56,
    height: 4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "393 215 367 215 367 199 393 215"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "341 215 367 215 367 199 341 215"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "393 215 367 199 341 215"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M389,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M377,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M365,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M353,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353,263v-8c0-2.21-1.79-4-4-4s-4,1.79-4,4v8"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 345,
    y: 225,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 353,
    y: 225,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 361,
    y: 225,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 369,
    y: 225,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 377,
    y: 225,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 385,
    y: 225,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 339,
    y: 215,
    width: 56,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 339,
    y: 243,
    width: 56,
    height: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 367,
    cy: 209,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 341,
    y1: 263,
    x2: 341,
    y2: 247
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 341,
    y1: 243,
    x2: 341,
    y2: 219
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 393,
    y1: 263,
    x2: 393,
    y2: 247
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 393,
    y1: 243,
    x2: 393,
    y2: 219
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 249,
    y: 119,
    width: 52,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 245,
    y: 135,
    width: 60,
    height: 104
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "245 263 245 135 305 135 305 263"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 249,
    y1: 139,
    x2: 249,
    y2: 259
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 301,
    y1: 259,
    x2: 301,
    y2: 139
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "241 263 241 239 309 239 309 263"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "241 263 241 239 309 239 309 263"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "301 135 301 119 249 119 249 135"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 301,
    y1: 131,
    x2: 249,
    y2: 131
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 249,
    y1: 123,
    x2: 301,
    y2: 123
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "245 263 245 243 305 243 305 263"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 143,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 143,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 143,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 143,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 155,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 155,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 155,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 155,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 167,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 167,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 167,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 167,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 179,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 179,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 179,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 179,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 191,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 191,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 191,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 191,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 203,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 203,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 203,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 203,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 215,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 215,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 215,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 215,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 253,
    y: 227,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 265,
    y: 227,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 277,
    y: 227,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 289,
    y: 227,
    width: 8,
    height: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 257,
    y: 247,
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 269,
    y: 247,
    width: 12,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 285,
    y: 247,
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 297,
    y: 247,
    width: 4,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 249,
    y: 247,
    width: 4,
    height: 16
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 321,
    cy: 251,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 321,
    cy: 251,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 321,
    y1: 251,
    x2: 321,
    y2: 263
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 313,
    cy: 243,
    r: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 313,
    y1: 253,
    x2: 313,
    y2: 263
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 313,
    cy: 243,
    r: 14
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 333,
    cy: 260,
    r: 3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 181,
    y: 211,
    width: 56,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 185,
    y: 215,
    width: 48,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 185,
    y: 235,
    width: 48,
    height: 28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 177,
    y: 223,
    width: 64,
    height: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 237,
    y1: 211,
    x2: 181,
    y2: 211
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 185,
    y1: 243,
    x2: 233,
    y2: 243
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 185,
    y1: 251,
    x2: 233,
    y2: 251
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 193,
    y1: 235,
    x2: 193,
    y2: 259
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 185,
    y1: 235,
    x2: 185,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201,
    y1: 235,
    x2: 201,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 209,
    y1: 235,
    x2: 209,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217,
    y1: 235,
    x2: 217,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 225,
    y1: 235,
    x2: 225,
    y2: 259
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233,
    y1: 235,
    x2: 233,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 181,
    y1: 231,
    x2: 181,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 185,
    y1: 235,
    x2: 233,
    y2: 235
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 237,
    y1: 231,
    x2: 237,
    y2: 263
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 177,
    y: 223,
    width: 64,
    height: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 181,
    y1: 211,
    x2: 181,
    y2: 223
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 185,
    y1: 215,
    x2: 185,
    y2: 223
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233,
    y1: 215,
    x2: 233,
    y2: 223
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 237,
    y1: 223,
    x2: 237,
    y2: 211
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 185,
    y1: 215,
    x2: 233,
    y2: 215
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201,
    y1: 223,
    x2: 201,
    y2: 215
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217,
    y1: 215,
    x2: 217,
    y2: 223
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 217,
    y1: 259,
    x2: 232.66,
    y2: 259
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 201,
    y1: 259,
    x2: 185,
    y2: 259
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 423,
    cy: 261,
    r: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 409,
    cy: 257,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 409,
    cy: 257,
    r: 6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 401,
    cy: 247,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 401,
    cy: 247,
    r: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 401,
    y1: 257,
    x2: 401,
    y2: 263
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 423,
    cy: 261,
    r: 2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "88.75 263 88.75 203 40.75 203 40.75 263"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 40.75,
    y: 239,
    width: 48,
    height: 4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 60.75,
    y: 259,
    width: 8,
    height: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "88.75 263 88.75 203 40.75 203 40.75 263"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.75,
    y1: 239,
    x2: 88.75,
    y2: 239
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 88.75,
    y1: 243,
    x2: 40.75,
    y2: 243
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.75,
    y: 247,
    width: 40,
    height: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 60.75,
    y1: 247,
    x2: 60.75,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 68.75,
    y1: 247,
    x2: 68.75,
    y2: 263
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 76.75,
    y1: 247,
    x2: 76.75,
    y2: 259
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 52.75,
    y1: 247,
    x2: 52.75,
    y2: 259
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.75,
    y: 223,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 44.75,
    y: 211,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.75,
    y: 223,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 56.75,
    y: 211,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.75,
    y: 223,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.75,
    y: 211,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.75,
    y: 223,
    width: 4,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 80.75,
    y: 211,
    width: 4,
    height: 8
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 175,
    cy: 247,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 175,
    cy: 247,
    r: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 175,
    y1: 259,
    x2: 175,
    y2: 263
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 169,
    cy: 255,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 169,
    cy: 255,
    r: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 169,
    y1: 261,
    x2: 169,
    y2: 263
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 29,
    cy: 251,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 29,
    cy: 251,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 29,
    y1: 259,
    x2: 29,
    y2: 263
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 17,
    cy: 259,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 17,
    cy: 259,
    r: 4
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171,57h-12c-1.1,0-2,.9-2,2s.9,2,2,2h12c1.1,0,2-.9,2-2s-.9-2-2-2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70,135h-6c-1.1,0-2-.9-2-2s.9-2,2-2h27c3.31,0,6-2.69,6-6s-2.69-6-6-6H47c-3.31,0-6,2.69-6,6s2.69,6,6,6h9c1.1,0,2,.9,2,2s-.9,2-2,2H29c-2.21,0-4,1.79-4,4s1.79,4,4,4h41c2.21,0,4-1.79,4-4s-1.79-4-4-4Z"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M380,127h-20c-1.1,0-2,.9-2,2s.9,2,2,2h20c1.1,0,2-.9,2-2s-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410,99h-24c-1.1,0-2,.9-2,2s.9,2,2,2h24c1.1,0,2-.9,2-2s-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M298,89h-12c-1.1,0-2,.9-2,2s.9,2,2,2h12c1.1,0,2-.9,2-2s-.9-2-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M372,115h-24c-1.11,0-2-.9-2-2s.89-2,2-2h14c3.31,0,6-2.69,6-6s-2.69-6-6-6h-60c-3.31,0-6,2.69-6,6s2.69,6,6,6h38c1.1,0,2,.9,2,2s-.9,2-2,2h-8c-2.21,0-4,1.79-4,4s1.79,4,4,4h40c2.21,0,4-1.79,4-4s-1.79-4-4-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M392,79h-52c-4.42,0-8,3.58-8,8s3.58,8,8,8h52c4.42,0,8-3.58,8-8s-3.58-8-8-8Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80,151h-14c-1.1,0-2,.9-2,2s.9,2,2,2h14c1.1,0,2-.9,2-2s-.9-2-2-2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M398,153h-12c-2.21,0-4,1.79-4,4s1.79,4,4,4h12c2.21,0,4-1.79,4-4s-1.79-4-4-4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72,111H30c-1.1,0-2,.9-2,2s.9,2,2,2h42c1.1,0,2-.9,2-2s-.9-2-2-2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103,83h28c1.1,0,2,.9,2,2s-.9,2-2,2h-6c-2.21,0-4,1.79-4,4s1.79,4,4,4h24c2.21,0,4-1.79,4-4s-1.79-4-4-4h-10c-1.1,0-2-.9-2-2s.9-2,2-2h20c3.31,0,6-2.69,6-6s-2.69-6-6-6h-56c-3.31,0-6,2.69-6,6s2.69,6,6,6Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 259,
    cy: 23,
    r: 22
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 437,
    y1: 263,
    x2: 1,
    y2: 263
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "65 203 65 175 89 175 89 163 109 163"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "29 243 29 191 53 191 53 203"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "133.17 147 165.17 147 165.17 167 177 167 177 123 197 123"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "305 147 341 147 341 187 353 187 353 175 373 175 373 191 385 191 385 209"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233,
    y1: 163,
    x2: 245,
    y2: 163
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLandscape);
export default __webpack_public_path__ + "static/media/login-landscape.4492996a5192663af75856839c4b08eb.svg";
export { ForwardRef as ReactComponent };